import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { initSafeAreaUpdates } from './utils/safeAreaUtils';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './services/queryClient';

// Script para garantir zoom em 100% e desabilitar double-tap
const preventZoom = () => {
  // Impede eventos de zoom por pinch
  document.addEventListener('gesturestart', (e) => {
    e.preventDefault();
  }, { passive: false });
  
  // Impede zoom por duplo toque
  document.addEventListener('touchstart', (e) => {
    if (e.touches.length > 1) {
      e.preventDefault();
    }
  }, { passive: false });
  
  // Força o zoom para 100% quando o usuário tentar alterar
  window.addEventListener('resize', () => {
    if (document.documentElement.clientWidth !== window.innerWidth) {
      window.scrollTo(0, 0);
      document.documentElement.style.zoom = '100%';
      // Força viewport em dispositivos iOS
      const viewport = document.querySelector('meta[name="viewport"]');
      if (viewport) {
        viewport.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no');
      }
    }
  });
  
  // Impede comportamento de duplo toque em elementos não-input
  document.addEventListener('click', (e) => {
    if (e.detail === 2 && 
        e.target.tagName !== 'INPUT' && 
        e.target.tagName !== 'TEXTAREA' && 
        !e.target.isContentEditable) {
      e.preventDefault();
    }
  }, { passive: false });
};

// Executar o script quando o documento estiver carregado
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preventZoom);
  } else {
    preventZoom();
  }
}

// Inicializar as safe areas para melhor suporte em dispositivos móveis
initSafeAreaUpdates();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// Registra o service worker para habilitar recursos de PWA
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    const waitingServiceWorker = registration.waiting;
    
    if (waitingServiceWorker) {
      waitingServiceWorker.addEventListener("statechange", (event) => {
        if (event.target.state === "activated") {
          window.location.reload();
        }
      });
      waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
    }
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
